"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOption = void 0;
const ramda_1 = require("ramda");
const defaultOptions = {
    Number: {
        format: {
            delimiter: ',',
            separator: '.'
        }
    }
};
exports.getOption = (options, path) => {
    return
};
